import React, { useEffect } from 'react'
import { PermissionType } from '@golden/gdk-admin'
import useGDK from './gdk/useGDK'
import useGDKStore from './gdk/useGDKStore'
import { useChecker } from '../../utils/admin/AdminRouteHook'
import depositErrorAudio from '../../assets/admin/audios/new_deposit_error_hint_voice.wav'

const DepositErrorAudio = new Audio(depositErrorAudio)
const resetAudioVoice = (el: HTMLAudioElement) => {
  el.currentTime = 0
}
const DepositErrorHandler: React.FC = () => {
  const gdk = useGDK()
  const me = useGDKStore.admin.me()
  const hasPermission = useChecker([PermissionType.DEPOSIT_ERROR_READ])

  useEffect(() => {
    if (!me || me.is_need_authenticator || me.is_need_update_password) return
    if (!hasPermission) return
    const handler = () => {
      resetAudioVoice(DepositErrorAudio)
      DepositErrorAudio.play()?.catch((error) => {
        // Ignore NotAllowedError which is thrown when the user hasn't interacted with the page yet
        // and the browser blocks the audio from playing
        if (error.name === 'NotAllowedError') return
        console.error(error)
      })
    }
    gdk.socket.instance.on('third_party.deposit.error.created', handler)
    return () => { gdk.socket.instance.off('third_party.deposit.error.created', handler) }
  }, [gdk, me, hasPermission])

  return null
}

export default React.memo(DepositErrorHandler)
